import React, { useState, useEffect } from "react";
import { Inbox, FileSearch, CalendarDays, AlertTriangle, Users2 } from "lucide-react";
import { apiClient } from "../../lib/api";

const Card = ({ icon: Icon, label, value, tone, testid }) => (
    <div
        data-testid={testid}
        className={`flex items-center gap-3 bg-white border rounded-lg px-4 py-3 ${
            tone === "warn" ? "border-amber-300 bg-amber-50" : "border-moebus-border"
        }`}
    >
        <div
            className={`w-9 h-9 rounded-md flex items-center justify-center flex-shrink-0 ${
                tone === "warn" ? "bg-amber-100 text-amber-700" : "bg-moebus-deep text-white"
            }`}
        >
            <Icon size={17} />
        </div>
        <div>
            <div className="text-xl font-bold text-moebus-deep leading-none">{value}</div>
            <div className="text-xs text-slate-500 mt-1">{label}</div>
        </div>
    </div>
);

export const AdminStats = ({ refreshKey }) => {
    const [stats, setStats] = useState(null);

    useEffect(() => {
        apiClient
            .get("/admin/stats")
            .then(({ data }) => setStats(data))
            .catch(() => {});
    }, [refreshKey]);

    if (!stats) return null;

    return (
        <div data-testid="admin-stats" className="mb-6 space-y-3">
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3">
                <Card icon={Users2} label="Bewerbungen gesamt" value={stats.total} testid="stat-total" />
                <Card icon={Inbox} label="Neu" value={stats.by_status?.["Neu"] ?? 0} testid="stat-new" />
                <Card
                    icon={FileSearch}
                    label="In Prüfung"
                    value={stats.by_status?.["In Prüfung"] ?? 0}
                    testid="stat-review"
                />
                <Card icon={CalendarDays} label="Letzte 30 Tage" value={stats.last_30_days} testid="stat-30days" />
                <Card
                    icon={AlertTriangle}
                    label="Über 7 Tage unbearbeitet"
                    value={stats.stale_count}
                    tone={stats.stale_count > 0 ? "warn" : undefined}
                    testid="stat-stale"
                />
            </div>
            {Object.keys(stats.by_position || {}).length > 0 && (
                <div className="flex flex-wrap gap-2" data-testid="stats-by-position">
                    {Object.entries(stats.by_position)
                        .sort((a, b) => b[1] - a[1])
                        .map(([pos, count]) => (
                            <span
                                key={pos}
                                className="inline-flex items-center gap-1.5 bg-white border border-moebus-border rounded-full px-3 py-1 text-xs text-slate-600"
                            >
                                {pos}
                                <span className="font-bold text-moebus-deep">{count}</span>
                            </span>
                        ))}
                </div>
            )}
        </div>
    );
};
